module.exports = __webpack_public_path__ + "assets/img/minion.037f17f0.svg";